// @ts-nocheck
import React, { createContext, useContext, useEffect, useRef, ReactNode } from 'react';
import { io, Socket } from 'socket.io-client';

interface SocketContextType {
  getSocket: (namespace: string, options?: Parameters<typeof io>[1]) => Socket;
}

const SocketContext = createContext<SocketContextType | undefined>(undefined);

interface SocketProviderProps {
  children: ReactNode;
  baseUrl: string;
}

export const SocketProvider = ({ children, baseUrl }: SocketProviderProps) => {
  const socketsRef = useRef<Map<string, Socket>>(new Map());



  const getSocket = (namespace: string, options: Parameters<typeof io>[1] = {}) => {
    const { auth } = options;

    if (!auth.accessToken || !auth.userUuid) {
      return;
    }

    const key = namespace.trim() === '' ? 'default' : namespace;
    if (!socketsRef.current.has(key)) {
      // Use baseUrl directly for default namespace.
      const nsUrl = namespace.trim() ? `${baseUrl}/${namespace}` : baseUrl;
      const socket = io(nsUrl, options);
  
      // Log when the socket actually connects.
      socket.on('connect', () => {
        console.log(`Socket connected in namespace "${key}":`, socket.id);
      });
      
      // Store the socket in the map.
      socketsRef.current.set(key, socket);
    } else {
      const existing = socketsRef.current.get(key);
      console.log(`Socket for namespace "${key}" retrieved:`, existing?.id);
    }
    return socketsRef.current.get(key)!;
  };

  return (
    <SocketContext.Provider value={{ getSocket }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocketContext = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocketContext must be used within a SocketProvider');
  }
  return context;
};
